var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 8.33417H8.33464C7.89261 8.33417 7.46868 8.50977 7.15612 8.82233C6.84356 9.13489 6.66797 9.55881 6.66797 10.0008V21.6675C6.66797 22.1095 6.84356 22.5335 7.15612 22.846C7.46868 23.1586 7.89261 23.3342 8.33464 23.3342H20.0013C20.4433 23.3342 20.8673 23.1586 21.1798 22.846C21.4924 22.5335 21.668 22.1095 21.668 21.6675V15.8342M20.418 7.08417C20.7495 6.75265 21.1991 6.56641 21.668 6.56641C22.1368 6.56641 22.5865 6.75265 22.918 7.08417C23.2495 7.41569 23.4357 7.86533 23.4357 8.33417C23.4357 8.80301 23.2495 9.25265 22.918 9.58417L15.0013 17.5008L11.668 18.3342L12.5013 15.0008L20.418 7.08417Z",
    stroke: "#09090B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.2261501d9dd9266cb09608ff7a323976.svg";
export { ForwardRef as ReactComponent };